import { useEffect, useRef, useState } from "react";
import AppRoutes from "./Routes/AppRoutes";
import keycloak from "./keycloak/keycloak";

export default function AppContent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    keycloak
      .init({
        onLoad: "login-required",
        pkceMethod: "S256",
        checkLoginIframe: false,               // allows auto-refresh without reload loop
        silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
        // redirectUri: process.env.REACT_APP_UI_URL + "/keycloak/callback",
      })
      .then((authenticated) => {
        if (authenticated) {
          setIsAuthenticated(true);
          if (keycloak.token) {
            localStorage.setItem("access_token", keycloak.token);
          } else {
            console.warn('Keycloak authenticated but token is missing');
          }
        } else {
          console.warn('Keycloak authentication failed');
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Keycloak init failed:", err);
        setIsLoading(false);
      });
  }, []);

//   Token refresh
  useEffect(() => {
    if (!keycloak || !keycloak.authenticated) return;

    const interval = setInterval(() => {
      if (keycloak.token) {
        keycloak
          .updateToken(30)
          .then((refreshed) => {
            if (refreshed) {
              console.log("Token refreshed successfully");
              if (keycloak.token) {
                localStorage.setItem("access_token", keycloak.token);
              }
            } else {
              console.log("Token is still valid, no refresh needed");
            }
          })
          .catch((error) => {
            console.error("Token refresh failed:", error);
            localStorage.removeItem("access_token");
            keycloak.logout({ redirectUri: window.location.origin });
          });
      }
    }, 20000); // Check every 20 seconds

    return () => clearInterval(interval);
  }, []);

  if (isLoading) return <p>Loading...</p>;

  return (
    <AppRoutes
      isAuthenticated={isAuthenticated}
      setIsAuthenticated={setIsAuthenticated}
    />
  );
}